import { useSelector } from 'react-redux';
import { planEndInDaysSelector } from 'redux/modules/pricing';

export default () => {
  const planEndInDays = useSelector(planEndInDaysSelector);

  return { planEndInDays };
};
